export default "__VITE_ASSET___wMKclPX__"